import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_prepayment",
  ref: "addPrepaymentRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_prepayment_header"
}
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body p-0" }
const _hoisted_10 = { class: "px-7 py-10 px-lg-17 border-bottom" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "form-group d-flex flex-wrap" }
const _hoisted_14 = { class: "col-form-label fw-bold required" }
const _hoisted_15 = {
  key: 0,
  class: "px-7 py-10 px-lg-17"
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-12" }
const _hoisted_18 = { class: "form-group mb-7" }
const _hoisted_19 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group mb-7" }
const _hoisted_22 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group mb-7" }
const _hoisted_25 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_26 = { class: "col-md-12" }
const _hoisted_27 = { class: "form-group mb-7" }
const _hoisted_28 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_29 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_30 = { class: "form-group mb-7" }
const _hoisted_31 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_32 = { class: "col-md-12" }
const _hoisted_33 = { class: "form-group mb-7" }
const _hoisted_34 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_35 = { class: "mb-7" }
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "form-group mb-7" }
const _hoisted_38 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_39 = { class: "col-md-12" }
const _hoisted_40 = { class: "form-group mb-7" }
const _hoisted_41 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_42 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_43 = { class: "mb-7" }
const _hoisted_44 = { class: "form-group mb-7" }
const _hoisted_45 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_46 = {
  key: 2,
  class: "col-md-12"
}
const _hoisted_47 = { class: "form-group mb-7" }
const _hoisted_48 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_49 = {
  key: 3,
  class: "col-md-12"
}
const _hoisted_50 = { class: "form-group mb-7" }
const _hoisted_51 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_52 = { class: "modal-footer align-items-center justify-content-end" }
const _hoisted_53 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_56 = { class: "svg-icon svg-icon-3 me-2 ms-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(_ctx.t("settlementCash.addPrepayment")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("settlementCash.paymentMethod")), 1),
                      _createVNode(_component_el_form_item, { prop: "external_transaction_platform" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            modelValue: _ctx.formData.external_transaction_platform,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.external_transaction_platform) = $event)),
                            placeholder: _ctx.t('common.plsSelect'),
                            onChange: _ctx.paymentMethodChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.option.paymentGatewayOptions, (item) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: item.value
                                }, [
                                  (item.value !== _ctx.PaymentGateway.InternalBank)
                                    ? (_openBlock(), _createBlock(_component_el_option, {
                                        key: 0,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder", "onChange"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              (_ctx.formData.external_transaction_platform != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("finacialReport.paidDate")), 1),
                          _createVNode(_component_el_form_item, { prop: "paid_time" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                class: "w-100",
                                modelValue: _ctx.formData.paid_time,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.paid_time) = $event)),
                                type: "date",
                                onChange: _cache[2] || (_cache[2] = ($event: any) => (
                          _ctx.commonChangeDefaultDate(
                            $event,
                            _ctx.formData,
                            'invoice_date'
                          )
                        )),
                                clearable: false,
                                placeholder: _ctx.t('common.pickDate'),
                                format: "DD.MM.YYYY"
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("finacialReport.paidAmount")), 1),
                          _createVNode(_component_el_form_item, { prop: "paid_amount" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                class: "w-100 text-start",
                                modelValue: _ctx.formData.paid_amount,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.paid_amount) = $event)),
                                precision: 2,
                                step: 0.01,
                                min: 0,
                                controls: false
                              }, null, 8, ["modelValue", "step"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.t("settlementCash.paidCurrency")), 1),
                          _createVNode(_component_el_form_item, { prop: "paid_currency" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.paid_currency,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.paid_currency) = $event)),
                                placeholder: _ctx.t('common.plsSelect'),
                                disabled: _ctx.option.itemData.currency !== ''
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.currency, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder", "disabled"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.t("settlementCash.allowPayments")), 1),
                          _createVNode(_component_el_form_item, { prop: "allow_payments" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.allow_payments,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.allow_payments) = $event)),
                                placeholder: _ctx.t('common.plsSelect'),
                                disabled: _ctx.option.itemData.allow_payments !== ''
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.option.allowPaymentsOptions, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder", "disabled"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      (
                    _ctx.formData.external_transaction_platform !=
                    _ctx.PaymentGateway.InternalBank
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.t("settlementCash.transactionNo")), 1),
                              _createVNode(_component_el_form_item, { prop: "external_transaction_id" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.external_transaction_id,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.external_transaction_id) = $event)),
                                    type: "text",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    clearable: ""
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("settlementCash.note")), 1),
                          _createVNode(_component_el_form_item, { prop: "note" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                class: "w-100",
                                modelValue: _ctx.formData.note,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.note) = $event)),
                                type: "textarea",
                                autosize: {
                          minRows: 6,
                        },
                                placeholder: _ctx.t('common.plsEnter'),
                                clearable: ""
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("h3", _hoisted_35, _toDisplayString(_ctx.t("settlementCash.receivedAccount")), 1),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.t("settlementCash.internalBankAccount")), 1),
                          _createVNode(_component_el_form_item, { prop: "debtor_entity_id" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.debtor_entity_id,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.debtor_entity_id) = $event)),
                                filterable: "",
                                clearable: "",
                                "remote-show-suffix": "",
                                remote: "",
                                "remote-method": _ctx.searchEntityItems,
                                loading: _ctx.options.entityLoading,
                                placeholder: _ctx.t('common.plsSelect'),
                                disabled: _ctx.option.itemData.account_id !== 0,
                                onChange: _ctx.debtorChange
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.entityOptions, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.debtor_number,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "remote-method", "loading", "placeholder", "disabled", "onChange"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.t("settlementCash.debtor")), 1),
                          _createVNode(_component_el_form_item, {
                            class: "text-gray-400",
                            prop: "debtor_entity_id"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.options.debtor_name ? _ctx.options.debtor_name : "--"), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      (
                    _ctx.formData.external_transaction_platform ==
                    _ctx.PaymentGateway.BankTransfer
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createElementVNode("h3", _hoisted_43, _toDisplayString(_ctx.t("settlementCash.paiedAccount")), 1),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.t("settlementCash.openingBank")), 1),
                              _createVNode(_component_el_form_item, { prop: "opening_bank" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.opening_bank,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.opening_bank) = $event)),
                                    type: "text",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    clearable: ""
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.formData.external_transaction_platform ==
                    _ctx.PaymentGateway.BankTransfer
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.t("settlementCash.oppositeBankAccountName")), 1),
                              _createVNode(_component_el_form_item, { prop: "pay_bank_account_name" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.pay_bank_account_name,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.pay_bank_account_name) = $event)),
                                    type: "text",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    clearable: ""
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.formData.external_transaction_platform ==
                    _ctx.PaymentGateway.BankTransfer
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.t("settlementCash.oppositeBankAccountNo")), 1),
                              _createVNode(_component_el_form_item, { prop: "pay_bank_account_no" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.pay_bank_account_no,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.pay_bank_account_no) = $event)),
                                    type: "text",
                                    placeholder: _ctx.t('common.plsEnter'),
                                    clearable: ""
                                  }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", {
                type: "button",
                class: "btn btn-light",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_53, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.cancel")), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-primary",
                disabled: _ctx.loading,
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                _withDirectives(_createElementVNode("span", null, [
                  _hoisted_55,
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                ], 512), [
                  [_vShow, _ctx.loading]
                ]),
                _withDirectives(_createElementVNode("span", null, [
                  _createElementVNode("span", _hoisted_56, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("common.submit")), 1)
                ], 512), [
                  [_vShow, !_ctx.loading]
                ])
              ], 8, _hoisted_54)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}